module.exports = __webpack_public_path__ + "static/media/roboto-italic.fe65b833.woff";